import type { WikiManifestNode } from '~features/wiki/utils/wikiManifestAccess';

export interface TocSectionNode {
	type: 'section';
	key: string;
	title: string;
	children: TocNode[];
}

export interface TocPageNode {
	type: 'page';
	key: string;
	title: string;
	id: string;
}

export type TocNode = TocSectionNode | TocPageNode;

export type { WikiManifest } from '~features/wiki/utils/wikiManifestAccess';

export const maxDepth = 6;

export const buildTocTree = (nodes: WikiManifestNode[]): TocNode[] => {
	return nodes.map((node) => {
		if (node.type === 'page') {
			return {
				type: 'page',
				key: `page:${node.id}`,
				title: node.title,
				id: node.id,
			};
		}

		return {
			type: 'section',
			key: `section:${node.id}`,
			title: node.title,
			children: buildTocTree(node.children),
		};
	});
};

export const nodeContainsPageId = (node: TocNode, pageId: string | undefined): boolean => {
	if (!pageId) {
		return false;
	}
	if (node.type === 'page') {
		return node.id === pageId;
	}
	return node.children.some((child) => nodeContainsPageId(child, pageId));
};
